// extracted by mini-css-extract-plugin
export default {"ProcessForm":"ProcessForm_ProcessForm__Zmduc"};